import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { QuestionBody } from 'apps/journey/components/user-profile-setup/components/user-profile-setup-modal/components/styled-question';
import { func, object } from 'prop-types';
import IconSelect from 'apps/journey/components/user-profile-setup/components/user-profile-setup-modal/components/icon-select';
import { resolve } from 'library/helpers/path-resolver';

const StyledQuestionBody = styled(QuestionBody)`
  max-width: 100%;
  @media (min-width: 600px) {
    max-width: 80%;
  }
`;

const MultiSelection = ({ answer, question, handleChange }) => {
  const [activeOptions, setActiveOptions] = useState({});

  useEffect(() => {
    let storedValues = JSON.parse(resolve(answer, 'multi', '{}'));
    setActiveOptions(storedValues);
  }, [question.id]);

  const setToActive = (option) => {
    setActiveOptions({
      ...activeOptions,
      [option.key]: !isActive(option)
    });
    handleChange({
      target: {
        name: 'multi',
        value: JSON.stringify({
          ...activeOptions,
          [option.key]: !isActive(option)
        })
      }
    });
  };

  const isActive = (option) => (
    resolve(activeOptions, `${option.key}`, false)
  );

  return (
    <StyledQuestionBody question={question}>
      <IconSelect answerChoices={question.answer_choices} handleClick={setToActive} isActive={isActive} />
    </StyledQuestionBody>
  );
};

MultiSelection.propTypes = {
  answer: object,
  question: object,
  handleChange: func
};

export default MultiSelection;
